(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["site-notice"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const bar = document.querySelector('[data-site-notice]');
    if (!bar) return;

    // Apparition avec animation
    requestAnimationFrame(() => {
    bar.classList.add('is-visible');
    });

    const close = bar.querySelector('[data-site-notice-close]');
    if (!close) return;

    close.addEventListener('click', () => {
    // Disparition avec la même transition CSS
    bar.classList.remove('is-visible');

    window.setTimeout(() => {
    bar.style.display = 'none';
    }, 260); // un peu plus long que la transition (250ms)
    });
});

  } catch(e) { console.error(e); }
})();
})();
